import { getSupabaseClient } from './supabaseClient';
import type { CurrentRoleCard, CurrentRoleRow } from '../types';

function rowToCard(row: CurrentRoleRow): CurrentRoleCard {
  return {
    id: row.id,
    school: row.school,
    degree: row.degree,
    description: row.description,
    image: row.image,
    status: row.status,
  };
}

export async function fetchCurrentRoles(): Promise<CurrentRoleCard[]> {
  const supabase = getSupabaseClient();
  if (!supabase) {
    throw new Error(
      'Supabase neni nakonfigurovan (chybi REACT_APP_SUPABASE_URL nebo REACT_APP_SUPABASE_PUBLISHABLE_KEY).',
    );
  }

  const { data, error } = await supabase
    .from('current_roles')
    .select('id, school, degree, description, image, status, sort_order')
    .order('sort_order', { ascending: true });

  if (error) {
    throw error;
  }

  return (data as CurrentRoleRow[]).map(rowToCard);
}
